import $ from 'jquery';

export default class HomeInstagram {
  constructor(section) {
    this.$el = $(section.el);
    this.settings = section.data;

    this.months = this.settings.months;
    this.dateFormat = this.settings.dateFormat;
    this.accessToken = this.settings.token;

    if (!this.accessToken || !this.accessToken.length) {
      return this._hasError(this.settings.error);
    }

    this.$photoContainer = this.$el.find('[data-instagram-photos]');
    this.$template = $(this.settings.template);
    this.$link = this.$el.find('[data-instagram-link]');
    this.$linkText = this.$el.find('[data-instagram-link-text]');

    this._getPhotos();
  }

  _hasError(response) {
    console.log(`Instagram error: ${response}`);
  }

  _getPhotos() {
    const url = `https://api.instagram.com/v1/users/self/media/recent?access_token=${this.accessToken}&count=6&callback=`;

    $.ajax({
      type: 'GET',
      dataType: 'jsonp',
      url,
      success: (response) => {
        if (response.meta.code !== 200) {
          this._hasError(response.meta.error_message);
        } else {
          this._renderPhotos(response);
        }
      },
    });
  }

  _renderPhotos(response) {
    this.$photoContainer.html('');
    const photos = response.data;

    // Grab username from first photo
    const { username } = photos[0].user;

    this.$link.attr('href', `https://instagram.com/${username}`);
    this.$linkText.html(username);
    this.$link.css('display', 'block');

    photos.forEach((photo) => {
      const $photo = this.$template.clone();

      const d = new Date(photo.created_time * 1000);
      const year = d.getFullYear();
      const month = this.months[d.getMonth()];
      const day = d.getDate();

      const timestamp = this.dateFormat
        .replace('%b', month)
        .replace('%d', day)
        .replace('%Y', year);

      // Set link
      $photo
        .find('.instagram-photo-container')
        .attr('href', photo.link);

      // Set photo
      $photo
        .find('.instagram-photo')
        .css('background-image', `url('${photo.images.standard_resolution.url}')`);

      // Set likes
      $photo
        .find('.instagram-likes')
        .append(photo.likes.count);

      // Set time posted
      $photo
        .find('.instagram-date')
        .text(timestamp);

      // Set caption
      const $caption = $photo.find('.instagram-caption');

      if (photo.caption) {
        $caption.text(photo.caption.text);
      } else {
        $caption.remove();
      }

      this.$photoContainer.append($photo);
    });
  }
}
